import { Flex } from "rebass/styled-components";
import { Headline } from "../../../components/text";
import { getClipTitle } from "../../Utilities/Clip";
import {
  TwitterShare,
  FacebookShare,
  ClipboardShare,
  WhatsAppShare,
} from "../Button/Share";
import { YouTubeShare } from "../Button/PlatformShare/Youtube";
import { TikTokUpload } from "../Button/PlatformShare/TikTok";
import {
  addAttributionParams,
  getAttributionUserId,
} from "../../Utilities/Attribution";
import { useUser } from "../../Hooks/useUser";

interface ShareContentsProps {
  clip?: any;
  card?: any;
  shareLink?: string;
}

export function ShareContents({ clip, card, shareLink }: ShareContentsProps) {
  const { allstarUser } = useUser();
  const isMontage = window.location.href.includes("montage");
  const hasMobile =
    clip.portraitUrl ||
    Boolean(
      clip.mobile?.find(
        (x: any) =>
          x.aspectRatio === "9:16" && ["Processed", "Ready"].includes(x.status),
      ),
    );

  const userId = getAttributionUserId(allstarUser);

  const clipLink =
    clip.url || !isMontage
      ? addAttributionParams(
          `https://${window.location.hostname}/clip?clip=${clip.shareId}`,
          userId,
        )
      : addAttributionParams(
          `https://${window.location.hostname}/montage?montage=${clip.shareId}`,
          userId,
        );
  const link =
    shareLink ||
    (card
      ? addAttributionParams(
          `https://${window.location.hostname}/studio/${card._id}`,
          userId,
        )
      : addAttributionParams(
          `https://${window.location.hostname}/clip?clip=${clip.shareId}`,
          userId,
        ));

  const title = card
    ? card.ui.title
    : clip.title
    ? clip.title
    : getClipTitle(clip);

  return (
    <>
      <Flex
        flexDirection="column"
        alignContent="center"
        maxWidth="490px"
        width="100%"
      >
        <Flex
          mb={[5, 7, 7, 7]}
          flexDirection="row"
          justifyContent="space-evenly"
        >
          <YouTubeShare
            hasMobile={hasMobile}
            size="social"
            classification="youTube"
            clip={clip}
            clipLink={clipLink}
          />
          <TikTokUpload
            hasMobile={hasMobile}
            size="social"
            classification="tikTok"
            clip={clip}
            clipLink={clipLink}
          />
          <WhatsAppShare link={link} clip={clip}></WhatsAppShare>
          <TwitterShare link={link} title={title} clip={clip}></TwitterShare>
          <FacebookShare link={link} clip={clip}></FacebookShare>
        </Flex>
        <Headline mb={4}>Copy Link</Headline>
        <ClipboardShare link={link} clip={clip}></ClipboardShare>
      </Flex>
    </>
  );
}
